export default {
  title: 'Désolé',
  message: 'L\'Espace client n\'est pas disponible pour le moment. Nous sommes désolés des inconvénients que cela peut vous causer.',
  unavailableUntil: 'Nos systèmes seront à nouveau disponibles le ',
  homeButton: 'Aller à l\'accueil',
};
